import React, { useEffect, useState } from 'react';

// import Tooltip from '@mui/joy/Tooltip';
import Button from '@mui/joy/Button';
import Stack from '@mui/joy/Stack';
import Chip from '@mui/joy/Chip';
import Sheet from '@mui/joy/Sheet';

import { getIcon } from 'utils/misc';
import { LoreDecorator } from 'components/Lore';

export default function LockedFeature(
    {
        children,
        lockedIconName = 'Lock',
        unlockedIconName = 'Close',
        color=undefined,
        copy,
        // tooltipPlacement = undefined,
        isLocked=true,
        setIsLocked,
        loreSlug=undefined,
        outlined=true,
        chip=false

    }: {
        children: React.ReactNode,
        copy: string,
        color?: 'primary' | 'neutral' | 'danger' | 'success' | 'warning' | undefined,
        // tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right' | undefined,
        lockedIconName?: string,
        unlockedIconName?: string,
        isLocked?: boolean,
        setIsLocked?: (isLocked: boolean) => void,
        loreSlug?: string,
        outlined?: boolean
        chip?: boolean
    }) {

    const [locked, setLocked] = useState(isLocked);
    const LockIcon = getIcon(lockedIconName);
        const LockOpenIcon = getIcon(unlockedIconName);
        const Icon = locked ? LockIcon : LockOpenIcon;

    useEffect(() => {
        if (isLocked !== undefined) {
            setLocked(isLocked);
        }
    }, [isLocked]);

    // We're going to say "Hide" and then "copy" ... so replace
    // "Show" or "View" with nothing
    const hideCopy = copy.replace(/Show|View/g, '');

    return (
        <Stack
            spacing={1}
        >

                <Stack spacing={1} pb={1} >
                    <Stack direction="row" spacing={1}
                        justifyContent="center"
                        alignItems="center" >

                        {loreSlug && <LoreDecorator slug={loreSlug} />}

                        <Button
                            variant="plain"
                            color={color}
                            size="sm"
                            onClick={() => { setLocked(!locked); setIsLocked && setIsLocked(!locked) }}

                            endDecorator={
                                <>
                                    <Icon
                                      sx={{
                                          transform: ( !locked ? 'scaleX(-1)' : undefined),
                                          transition: 'all 0.4s ease-in-out',
                                          opacity: ( !locked ? 0.5 : 1),
                                      }} />

                                </>
                            }
                        >{locked ? hideCopy : copy }</Button>

                        </Stack>

                        { !locked &&
                            <Sheet
                                variant="soft"
                                color={color}
                                sx={{

                                    p: 1,
                                    //  border: locked ? 0 : 1,
                                    color: "success", // color,
                                    variant: 'soft',
                borderColor: outlined ? (locked ? 'transparent' : color) : 'transparent',
                borderRadius: "md",
                height: "auto",
                                }}>
                        {children}
                        </Sheet> }
                </Stack>

            {false &&
                <Stack
                    direction="row" justifyContent="center" spacing={1}
                > { loreSlug !== undefined && <LoreDecorator slug={loreSlug} /> }

                    <Stack direction="row" spacing={1}>


                        {chip ?

                            <Chip
                                variant="plain"
                                color={color}
                                size="sm"
                                onClick={() => { setLocked(!locked); setIsLocked && setIsLocked(!locked) }}
                                endDecorator={<LockIcon />}
                            >{copy}</Chip>
                            :

                            <Button
                                color={color}
                                variant="plain"
                                size="sm"
                                onClick={() => { setLocked(!locked); setIsLocked && setIsLocked(!locked) }}
                                endDecorator={<LockIcon sx={{ transform: 'scaleX(-1);' }} />}
                            >{copy}</Button>
                        }
                    </Stack>

                </Stack>

            }
        </Stack>

    );
}
